import { render, staticRenderFns } from "./SellersList.vue?vue&type=template&id=52b227d1&scoped=true&"
import script from "./SellersList.vue?vue&type=script&lang=js&"
export * from "./SellersList.vue?vue&type=script&lang=js&"
import style0 from "./SellersList.vue?vue&type=style&index=0&id=52b227d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b227d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VList,VListTile,VListTileAction,VListTileAvatar,VListTileContent})
